// class PredictiveSearch extends HTMLElement {
//   constructor() {
//     super();

//     this.input = this.querySelector('input[type="search"]');
//     this.resultBox = this.querySelector('#tr-search-drawer__result');
//     this.search_drawer = document.getElementById('tr-search-drawer');
//     this.suggestionsBox = this.querySelector('.tr-search-drawer__content__items');

//     this.input.addEventListener('input', this.debounce((event) => {
//       this.onChange(event);
//     }, 300).bind(this));
//   }

//   onChange() {
//     const searchTerm = this.input.value.trim();

//     if (!searchTerm.length) {
//       this.close();
//       return;
//     }

//     this.getSearchResults(searchTerm);
//   }


// getSearchResults(searchTerm) {
//   const encodedTerm = encodeURIComponent(searchTerm);
//   fetch(`/search/suggest?q=${encodedTerm}&section_id=tr-search-drawer__result`)
//     .then((response) => {
//       if (!response.ok) {
//         throw new Error(response.status);
//       }
//       return response.text();
//     })
//     .then((text) => {
//       const parser = new DOMParser();
//       const doc = parser.parseFromString(text, 'text/html');

//       const resultMarkup = doc.querySelector('#tr-search-drawer__result');
//       const suggestionsMarkup = doc.querySelector('.tr-search-drawer__content__items');

//       const hasResults = resultMarkup && resultMarkup.innerHTML.trim().length > 0;
//       const hasSuggestions = suggestionsMarkup && suggestionsMarkup.innerHTML.trim().length > 0;

//       const noResultOnSearch = document.querySelector('#tr-search-drawer');

//       if (hasResults && hasSuggestions) {
//         if (this.resultBox) this.resultBox.innerHTML = resultMarkup.innerHTML;
//         if (this.suggestionsBox) this.suggestionsBox.innerHTML = suggestionsMarkup.innerHTML;
//         this.open();
//         if (noResultOnSearch) noResultOnSearch.classList.remove('empty-search-result');
//       } else {
//         if (noResultOnSearch) noResultOnSearch.classList.add('empty-search-result');
//         this.close();
//       }
//     })
//     .catch((error) => {
//       const noResultOnSearch = document.querySelector('#tr-search-drawer');
       
//       this.close();
//       console.error(error);
//     });
// }


//   open() {
//     this.resultBox.style.display = 'block';
//     this.suggestionsBox.style.display = 'flex';
//     this.search_drawer.classList.add('full_width');
//   }

//   close() {
//     this.resultBox.style.display = 'none';
//     this.suggestionsBox.style.display = 'none';
//     this.search_drawer.classList.remove('full_width');
//   }

//   debounce(fn, wait) {
//     let t;
//     return (...args) => {
//       clearTimeout(t);
//       t = setTimeout(() => fn.apply(this, args), wait);
//     };
//   }
// }

// customElements.define('predictive-search', PredictiveSearch);
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.resultBox = this.querySelector('#tr-search-drawer__result');
    this.search_drawer = document.getElementById('tr-search-drawer');
    this.suggestionsBox = this.querySelector('.tr-search-drawer__content__items');

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const encodedTerm = encodeURIComponent(searchTerm);

    fetch(`/search/suggest?q=${encodedTerm}&section_id=tr-search-drawer__result`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.text();
      })
      .then((text) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');

        const resultMarkup = doc.querySelector('#tr-search-drawer__result');
        const suggestionsMarkup = doc.querySelector('.tr-search-drawer__content__items');

        const hasResults = resultMarkup && resultMarkup.innerHTML.trim().length > 0;
        const hasSuggestions = suggestionsMarkup && suggestionsMarkup.innerHTML.trim().length > 0;

        const noResultOnSearch = document.querySelector('#tr-search-drawer');

        if (hasResults || hasSuggestions) {
          if (hasResults && this.resultBox) {
            this.resultBox.innerHTML = resultMarkup.innerHTML;
          }

          if (hasSuggestions && this.suggestionsBox) {
            this.suggestionsBox.innerHTML = suggestionsMarkup.innerHTML;
          }

          this.open();
          if (noResultOnSearch) noResultOnSearch.classList.remove('empty-search-result');
        } else {
          if (noResultOnSearch) noResultOnSearch.classList.add('empty-search-result');
          this.close();
        }
      })
      .catch((error) => {
        const noResultOnSearch = document.querySelector('#tr-search-drawer');
        this.close();
        console.error(error);
      });
  }

  open() {
    if (this.resultBox) this.resultBox.style.display = 'block';
    if (this.suggestionsBox) this.suggestionsBox.style.display = 'flex';
    if (this.search_drawer) this.search_drawer.classList.add('full_width');
  }

  close() {
    if (this.resultBox) this.resultBox.style.display = 'none';
    if (this.suggestionsBox) this.suggestionsBox.style.display = 'none';
    if (this.search_drawer) this.search_drawer.classList.remove('full_width');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
